module.exports = __webpack_public_path__ + "static/media/0_2018_09_30.1cb9d214.jpg";